import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AggridsaciComponent} from '../../advantage/aggridsaci/aggridsaci.component';
import {VenDetfacZ} from '../../ven/veninterfaces/vendetfacz';
import {AggridBanComponent} from '../../ban/aggrid-ban/aggrid-ban.component';
import {CellEditorPrueba} from '../../advantage/config/cell-edit-prueba';
import {ComdetnotrecService} from '../comservicios/comdetnotrec.service';

@Component({
  selector: 'app-comdetnotrec',
  templateUrl: './comdetnotrec.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class ComdetnotrecComponent implements OnInit, OnChanges {
  // @ts-ignore
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  largo: string;
  allSelected: boolean;
  rowSelection = 'multiple';
  public frameworkComponents;
  @Input() notrecNumero: string;
  @Output() detallesSeleccionados = new EventEmitter<VenDetfacZ[]>();
  @Output() signalSalir = new EventEmitter<boolean>();
  rowStyle;
  defaultColDef;
  columnDefsDetfac = [
    {
      headerName: '', field: 'SELECCIONADO', cellRendererFramework: AggridBanComponent, editable: false, width: 50
    },
    { // 0
      headerName: 'Tipo', field: 'DETFACPRO_TIPODET', width: 80, editable: false,
      // editable: true,
    },
    { // 0
      headerName: 'Bodega', field: 'BOD_CODIGO', width: 80, editable: false,
      // editable: true,
    },
    { // 1
      headerName: 'Código', field: 'DETNOTREC_CODIGO', width: 150, editable: false,
    },
    { // 2
      headerName: 'Descripción', field: 'DETNOTREC_DESCRIPCION', width: 200, editable: false
    },
    { // 4
      headerName: 'Ice', field: 'DETNOTREC_TRIBICE', width: 60, editable: false
      // , editable: true,
    },
    {
      headerName: 'Unidad', field: 'DETNOTREC_UNIDAD',  editable: false, width: 80,
    },
    { // 6
      headerName: 'Cantidad', field: 'DETNOTREC_CANTIDAD', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 7
      headerName: 'Costo', field: 'DETNOTREC_COSTO', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 8
      headerName: 'Descuento', field: 'DETNOTREC_PORDES', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 8
      headerName: 'Dsct1(%)', field: 'DETNOTREC_PORDES', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 8
      headerName: 'Dsct2(%)', field: 'DETNOTREC_PORDES2', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 8
      headerName: 'Dsct3(%)', field: 'DETNOTREC_PORDES3', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
    { // 9
      headerName: 'Total', field: 'DETNOTREC_TOTAL', cellStyle: {textAlign: 'right'}, width: 90, editable: false
      // , editable: true,
    },
  ];
  constructor(public detnotRecService: ComdetnotrecService) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return {background: '#D6EAF8'};
      }
    };
    this.defaultColDef = {
      editable: true,
      width: 100,
      objeto: 'detnotrecdev'
    };
  }
  ngOnInit() {
    this.allSelected = false;
    this.largo = '400';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.notrecNumero !== undefined) {
      this.detnotRecService.getDetnotRec(this.notrecNumero).subscribe((res) => {
        this.detnotRecService.detnotrec = res;
        this.detnotRecService.detnotrec.map((detf) => {
          detf.SELECCIONADO = false;
          detf.DETNOTREC_COSTO = Number(detf.DETNOTREC_COSTO).toFixed(4);
          detf.DETNOTREC_CANTIDAD = Number(detf.DETNOTREC_CANTIDAD).toFixed(4);
        });
      });
    }
  }
  seleccionar() {
    if (this.allSelected === true) {
      this.detnotRecService.detnotrec.map((detf) => {
        detf.SELECCIONADO = true;
      });
      this.aggrid.refreshaggrid(this.detnotRecService.detnotrec, this.defaultColDef.objeto);
    } else if (this.allSelected === false) {
      this.detnotRecService.detnotrec.map((detf) => {
        detf.SELECCIONADO = false;
      });
      this.aggrid.refreshaggrid(this.detnotRecService.detnotrec, this.defaultColDef.objeto);
    }
  }
  enviarDetalles() {
    let arregloaEnviar: VenDetfacZ[];
    arregloaEnviar = [];
    this.detnotRecService.detnotrec.map((detf) => {
      if (detf.SELECCIONADO === true) {
        arregloaEnviar.push(detf);
      }
    });
    this.detallesSeleccionados.emit(arregloaEnviar);
  }
  enviarSalir() {
    this.signalSalir.emit(true);
  }

}
